// Traductions Plan d'Exécution — PRÉ-SEED 500K, 6 mois (Sept → Fév)
// Aligné mock.js v5.0 (objectifsY1, equipeCommerciale, previsionsY1)

export const phasesFR = [
  {
    titre: 'PHASE 1 — Activation & Premières Signatures',
    periode: 'Septembre M1 — Octobre M2',
    objectif: 'Démarrer la machine commerciale et signer les premiers traiteurs additionnels. Objectif : ~158-208 écoles + 141-191 garderies à fin M2.',
    delivrables: [
      'Onboarding des 3 vendeurs + Top Closer Québec',
      'Activation lead provider — listes commerciales qualifiées prêtes',
      'Démarrage cadence de signature : 15 traiteurs/mois cible (les vendeurs qualifient et signent ; les démos sont gérées par le directeur des ventes)',
      'Lancement support onboarding — premiers traiteurs en production',
      'Activation Programme Partenaire Fondateur (closing argumentaire)',
      'Première vague de signatures : objectif Min 20 traiteurs / Réaliste 27 traiteurs à M2',
      'Validation product-market fit avec données réelles parents / écoles / garderies',
      'Budget Phase 1-3 (GTM intensif) : ~83K $/mois'
    ],
    justification: 'Démarrage immédiat avec la traction existante (6 traiteurs, 73 écoles, 51 garderies en <1 mois) comme socle de crédibilité.'
  },
  {
    titre: 'PHASE 2 — Scaling Commercial',
    periode: 'Novembre M3 — Décembre M4',
    objectif: 'Accélérer la cadence et atteindre la masse critique. Objectif : ~329-479 écoles + 320-470 garderies à fin M4.',
    delivrables: [
      'Cadence pleine : 15 traiteurs signés / mois (Min 43-55, Réaliste 63-82 cumulés à M4)',
      'Sezzle BNPL déjà activé pour les traiteurs (en production)',
      'Activation abonnement parent optionnel 2$/mois (50% don écoles) dès fin M2',
      'Stabilisation produit + ajustements UX basés sur usage terrain',
      'Premier seuil de rentabilité opérationnelle approché (revenu mensuel ~76-122K $ à M4)',
      'Renforcement support onboarding (volume traiteurs croissant)',
      'Préparation transition Tier 1 → Tier 2 pour premiers traiteurs (SaaS 150$/mois min à 26+)'
    ],
    justification: 'À M3-M4 le modèle prouve son unit economics. Les revenus rattrapent les dépenses GTM intensives.'
  },
  {
    titre: 'PHASE 3 — Atteinte des Objectifs M6',
    periode: 'Janvier M5 — Février M6',
    objectif: 'Verrouiller les objectifs M6 (Min 500+500 ou Réaliste 750+750 établissements) et atteindre le break-even mensuel.',
    delivrables: [
      'Atteinte cible Min : 500 écoles + 500 garderies, 42 500 repas/jour, 61,2M $ GMV',
      'Atteinte cible Réaliste : 750 écoles + 750 garderies, 63 750 repas/jour, 91,8M $ GMV',
      'Break-even opérationnel atteint (revenu mensuel ~130-206K $ vs dépenses 83K $)',
      'Premier mois positif : M5 (Min +19,6K $) ou M3 (Réaliste -3,2K $ → M4 +38,5K $)',
      'Données de traction consolidées pour la ronde seed',
      'Préparation matériaux investisseurs (data room, métriques, projections)',
      'Lancement ronde seed début Février : ~10% de la valeur établie à ce moment'
    ],
    justification: 'M6 est le pivot stratégique : EcoLunch démontre la viabilité du modèle avec données réelles. La ronde seed est lancée en force.'
  },
  {
    titre: 'PHASE 4 — Post-Seed (Mars → Août)',
    periode: 'Mars M7 — Août M12',
    objectif: 'Croissance post-seed : Min 1 000+1 000 ou Réaliste 1 500+1 500 établissements à M12. Dépenses passent à ~66K $/mois (post-GTM intense).',
    delivrables: [
      'Croissance organique + accélération provinciale (ON, AB) selon le capital seed obtenu',
      'Tarification Tier 2 activée pour tous les traiteurs 26+ (3,9% + 0,30$ + SaaS 150$/mois min)',
      'Activation potentielle EcoLunch Connect (1,0% à 2,5% en sus, hors prévisions actuelles)',
      'Cible M12 Min : 1 000 + 1 000 établissements, 122M $ GMV, 3,38M $ revenus annualisés',
      'Cible M12 Réaliste : 1 500 + 1 500 établissements, 184M $ GMV, 5,21M $ revenus annualisés',
      'Cash position fin Y1 : Min ~1,30M $ / Réaliste ~2,24M $',
      'Note : L\'étendue exacte de la Phase 4 dépend du capital seed levé et du soutien stratégique obtenu'
    ],
    justification: 'Phase 4 marque la transition pré-seed → seed. Les chiffres au-delà de Février dépendent de la ronde et de la traction réelle atteinte.'
  }
];

export const phasesEN = [
  {
    titre: 'PHASE 1 — Activation & First Signings',
    periode: 'September M1 — October M2',
    objectif: 'Kickstart the commercial machine and sign first additional caterers. Target: ~158-208 schools + 141-191 daycares by end of M2.',
    delivrables: [
      'Onboarding of 3 sales reps + Quebec Top Closer',
      'Lead provider activation — qualified commercial lists ready',
      'Start signing cadence: 15 caterers/month target (reps qualify & sign; demos managed by Sales Director)',
      'Onboarding support team launch — first caterers in production',
      'Founder Partner Program activation (closing argument)',
      'First wave of signings: target Min 20 caterers / Realistic 27 caterers at M2',
      'Product-market fit validation with real parents / schools / daycares data',
      'Phase 1-3 budget (intensive GTM): ~$83K/month'
    ],
    justification: 'Immediate start leveraging existing traction (6 caterers, 73 schools, 51 daycares in <1 month) as a credibility foundation.'
  },
  {
    titre: 'PHASE 2 — Commercial Scaling',
    periode: 'November M3 — December M4',
    objectif: 'Accelerate cadence and reach critical mass. Target: ~329-479 schools + 320-470 daycares by end of M4.',
    delivrables: [
      'Full cadence: 15 caterers signed/month (Min 43-55, Realistic 63-82 cumulative at M4)',
      'Sezzle BNPL already activated for caterers (in production)',
      'Optional parent subscription $2/month (50% school donation) activation from end of M2',
      'Product stabilization + UX adjustments based on field usage',
      'First operational break-even threshold approached (monthly revenue ~$76-122K at M4)',
      'Onboarding support reinforcement (growing caterer volume)',
      'Tier 1 → Tier 2 transition prep for first caterers (SaaS $150/month min at 26+)'
    ],
    justification: 'By M3-M4 the model proves its unit economics. Revenue catches up with intensive GTM expenses.'
  },
  {
    titre: 'PHASE 3 — Reach M6 Objectives',
    periode: 'January M5 — February M6',
    objectif: 'Lock M6 targets (Min 500+500 or Realistic 750+750 institutions) and reach monthly break-even.',
    delivrables: [
      'Min target reached: 500 schools + 500 daycares, 42,500 meals/day, $61.2M GMV',
      'Realistic target reached: 750 schools + 750 daycares, 63,750 meals/day, $91.8M GMV',
      'Operational break-even achieved (monthly revenue ~$130-206K vs expenses $83K)',
      'First positive month: M5 (Min +$19.6K) or M3 (Realistic -$3.2K → M4 +$38.5K)',
      'Consolidated traction data for the seed round',
      'Investor materials preparation (data room, metrics, projections)',
      'Seed round launch early February: ~10% of value established at that time'
    ],
    justification: 'M6 is the strategic pivot: EcoLunch demonstrates model viability with real data. The seed round is launched with strength.'
  },
  {
    titre: 'PHASE 4 — Post-Seed (March → August)',
    periode: 'March M7 — August M12',
    objectif: 'Post-seed growth: Min 1,000+1,000 or Realistic 1,500+1,500 institutions at M12. Expenses drop to ~$66K/month (post intensive GTM).',
    delivrables: [
      'Organic growth + provincial acceleration (ON, AB) depending on seed capital obtained',
      'Tier 2 pricing activated for all 26+ caterers (3.9% + $0.30 + SaaS $150/month min)',
      'Potential EcoLunch Connect activation (1.0% to 2.5% on top, outside current forecasts)',
      'Min M12 target: 1,000 + 1,000 institutions, $122M GMV, $3.38M annualized revenue',
      'Realistic M12 target: 1,500 + 1,500 institutions, $184M GMV, $5.21M annualized revenue',
      'Y1 end cash position: Min ~$1.30M / Realistic ~$2.24M',
      'Note: Exact Phase 4 extent depends on seed capital raised and strategic support obtained'
    ],
    justification: 'Phase 4 marks the pre-seed → seed transition. Numbers beyond February depend on the round and actual traction achieved.'
  }
];

export const planTexts = {
  fr: {
    titre: "Plan d'Exécution",
    intro: `Le plan d'exécution du pré-seed 500K se déploie en 4 phases sur 6 mois (Septembre → Février). À partir de Février, la Phase 4 démarre conditionnellement à la réussite de la ronde seed.`,
    phaseLabel: 'Phase',
    periodeLabel: 'Période :',
    objectifLabel: 'Objectif :',
    livrablesLabel: 'Livrables :'
  },
  en: {
    titre: 'Execution Plan',
    intro: `The $500K pre-seed execution plan unfolds in 4 phases over 6 months (September → February). Starting February, Phase 4 begins conditional on the seed round's success.`,
    phaseLabel: 'Phase',
    periodeLabel: 'Period:',
    objectifLabel: 'Objective:',
    livrablesLabel: 'Deliverables:'
  }
};
